module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"settings.alibaba.title":"Alibaba Cloud Connections","settings.alibaba.subtitle":"All cloud connections importing Alibaba Cloud usage data in this tenant."}}')
  delete Component.options._Ctor
}
